import { TheSocietyType } from "../../types/commonTypes/theSocietyType";

export const theSocietyFixedCapitalInitialState : TheSocietyType = {
    legalForm: '',
    object: '',
    duration: 0,
    acronym: '',
    minimalCapital: 0,
    maximalCapital: 0,
    initialCapital: 0,
    capital: 0
}